import { buildDeserializer, buildSerializer } from "lib/serializerUtils";

const reportJobSerializerMap = {
  documentStatus: "document_status",
  id: "id",
  status: "status",
  file: "file",
  report: "report",
};

const serializeMap = {
  billingRunId: "billing_run_id",
  created: "created",
  dueDate: "due_date",
  emailIds: "email_ids",
  exportErrors: "export_errors",
  exportWarnings: "export_warnings",
  hasFinancialChanges: "has_financial_changes",
  hasCosmeticChanges: "has_cosmetic_changes",
  id: "id",
  integrationStatus: "integration_status",
  issuedDate: "issued_date",
  issuerBusinessId: "issuer_business_id",
  latestInterestChargeDate: "latest_interest_charge_date",
  lastModified: "last_modified",
  livestockSaleIds: "livestock_sale_ids",
  number: "number",
  paidDate: "paid_date",
  recipientBusinessId: "recipient_business_id",
  reportJobs: reportJobSerializerMap,
  status: "status",
  totalAmountDollars: "total_amount_dollars",
  totalPaidCents: "total_paid_cents",
  totalTaxAmountDollars: "total_tax_amount_dollars",
  type: "type",
  xeroBrandingTheme: "xero_branding_theme",
  xeroInvoiceId: "xero_invoice_id",
};

const nestedObjectMap = {
  report_jobs: "reportJobs",
};

export const serializeBillingDocument = buildSerializer(
  serializeMap,
  "billingDocument",
  nestedObjectMap,
);

export const deserializeBillingDocument = buildDeserializer(
  serializeMap,
  "billingDocument",
  nestedObjectMap,
);
